"use strict";
exports.__esModule = true;
exports.instances = exports.data = void 0;
exports.data = [
    {
        product: undefined,
        instance: {
            uuid: '373ab7d4-57a7-11e9-831f-42010a840080'
        },
        name: 'withConditions',
        uuid: 'bbe8b149-5072-11e9-831f-42010a840080'
    },
    {
        product: undefined,
        instance: {
            uuid: '373ab7d4-57a7-11e9-831f-42010a840080'
        },
        name: 'sunday',
        uuid: 'a18028ab-95b7-11e9-8e3b-42010aac0008'
    }
];
exports.instances = [
    {
        uuid: 'workflow-instance-uuid-1',
        instance: { uuid: 'uuid1' },
        workflow: { uuid: 'bbe8b149-5072-11e9-831f-42010a840080' },
        logDateAdded: new Date()
    }
];
